import bgPhoto from "../assets/all-4-bg.jpg";
import logo3 from "../assets/logo3-sf.png";
import omImage from "../assets/om.png";
import name from "../assets/landigpage-name.png";

import button1 from "../assets/sutra.jpg";
import button2 from "../assets/taravali.jpg";
import button3 from "../assets/gs.jpg";
import button4 from "../assets/hyps.jpg";

const HomePage = () => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Background Image */}
      <img
        src={bgPhoto}
        alt="Landing Page"
        style={{
          margin: "0px",
          padding: "0px",
          width: "100%",
          height: "100vh",
          objectFit: "cover",
          objectPosition: "75% center",
        }}
      />

      {/* OM Logo */}
      <div
        className="landing-om"
        style={{
          position: "absolute",
          top: "2vh",
          left: "65%",
          transform: "translateX(-50%)",
          zIndex: 10,
        }}
      >
        <img
          src={omImage}
          alt="Om"
          style={{
            height: "10vh",
            width: "auto",
            objectFit: "contain",
          }}
        />
      </div>

      {/* Top-right logos */}
      <div
        className="landing-logos"
        style={{
          position: "absolute",
          top: "1.5vh",
          right: "1vw",
          display: "flex",
          gap: "1vw",
          zIndex: 10,
        }}
      >

        <a
          href="https://samskritifoundation.org/"
          target="_self"
          rel="noopener noreferrer"
        >
          <img src={logo3} alt="Samskriti Foundation Logo" style={{ height: "12vh" }} />
        </a>

      </div>

<img
        className="landing-name"
        src={name}
        alt="Title Name"
        style={{
          position: "absolute",
          width: "40vw",
          bottom: "45vh",
          right: "10vw",
        }}
      />

      {/* ========================= */}
      {/* 4 IMAGE BUTTONS */}
      {/* ========================= */}

      <div className="landing-buttons">

        {/* Button 1 */}
        <a
          href="https://test3.samskritifoundation.org/yoga_sutra"
          className="landing-button button-1"
        >
          <img src={button1} alt="Button 1" />
        </a>

        {/* Button 2 */}
        <a
          href="https://test3.samskritifoundation.org/yoga_taravali"
          className="landing-button button-2"
        >
          <img src={button2} alt="Button 2" />
        </a>

        {/* Button 3 */}
        <a
          href="https://test3.samskritifoundation.org/gheranda_samhita"
          className="landing-button button-3"
        >
          <img src={button3} alt="Button 3" />
        </a>

        {/* Button 4 */}
        <a
          href="https://test3.samskritifoundation.org/hatha_yoga_pradeepika"
          className="landing-button button-4"
        >
          <img src={button4} alt="Button 4" />
        </a>

      </div>

      {/* Mobile Portrait Styles */}
      <style>
        {`

/* ========================= */
/* DESKTOP */
/* ========================= */

.landing-buttons {
  position: absolute;
  left: 70%;
  bottom: 16vh;
  transform: translateX(-50%);

  display: grid;

  grid-template-columns: repeat(2, auto);

  justify-content: center;
  align-items: center;

  column-gap: 3vw;
  row-gap: 2vh;

  width: 70vw;

  z-index: 20;
}

.landing-button {
  display: block;
  cursor: pointer;
}

.landing-button img {
  display: block;
  width: 18vw;
  height: auto;
  object-fit: contain;
}

.landing-button:hover {
  transform: scale(1.05);
}


/* ========================= */
/* MOBILE PORTRAIT */
/* ========================= */

@media (max-width: 600px) and (orientation: portrait) {

  .landing-om {
    top: 5vh !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
  }

  .landing-om img {
    height: 7vh !important;
    width: auto !important;
  }

  .landing-logos {
    top: 5vh !important;
    right: 3vw !important;
    gap: 46vw !important;
  }

  .landing-logos img {
    height: 8vh !important;
    width: auto !important;
  }

.landing-name {
        width: 88vw !important;
        max-width: 420px !important;
        transform: translateX(5%) !important;
        top: 24vh !important;
  }

  .landing-buttons {
    bottom: 30vh !important;
    width: 100vw !important;

    grid-template-columns: repeat(2, auto) !important;

    column-gap: 5vw !important;
    row-gap: 2vh !important;

    transform: translateX(-68%) !important;

  }

  .landing-button img {
    width: 38vw !important;
    height: auto !important;
  }

  .landing-button:hover {
    transform: none;
  }
}
        `}
      </style>
    </div>
  );
};

export default HomePage;
